module.exports = __webpack_public_path__ + "img/75687.4f2d9fe5.svg";